import React, { useEffect, useState } from 'react';
import ConferenceCountdown from './ConferenceCountdown';
import conference2026Abstracts from '../data/conference2026Abstracts';
import './Schedule.css';

const schedulePanelsMarkup = `
  <section class="schedule-panel" id="day1">
    <div class="panel-head">
      <div>
        <div class="panel-title">Day 1 / 04.11</div>
        <div class="panel-subtitle">开幕式、主题演讲与并行分论坛</div>
      </div>
    </div>
    <div class="session-grid">
      <article class="session-card full">
        <h3>开幕式与主题演讲</h3>
        <div class="session-en">Opening Ceremony & Keynote Speech</div>
        <div class="session-meta">
          <span>时间：09:00-12:00</span>
          <span>地点：燕京学堂报告厅 / B102</span>
          <span>主持人：王雷</span>
        </div>
        <div class="session-note"><strong>主持人</strong>王雷 中国传媒大学动画与数字艺术学院院长</div>
        <div class="session-note"><strong>主题演讲评议人</strong>芮玛窦 Matteo Ravasio（北京大学艺术学院研究员）。</div>
        <div class="talk-list">
          <div class="talk-item">
            <div class="talk-time">09:00-10:00</div>
            <div class="talk-title">开幕式 / Opening Ceremony</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">10:00-12:00</div>
            <div class="talk-title">永恒回返：Roguelike 游戏与电子游戏诗学</div>
            <div class="talk-title-en">ETERNAL RETURNS: ROGUELIKES AND VIDEOGAME POETICS</div>
            <div class="talk-speaker">主讲人：米格尔·西卡特 Miguel Sicart，哥本哈根信息技术大学副教授</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">10:00-12:00</div>
            <div class="talk-title">作为娱乐、艺术与表演的电脑游戏：一种存在论诠释学</div>
            <div class="talk-title-en">EXISTENTIAL HERMENEUTICS FOR COMPUTER GAMES AS ENTERTAINMENT, ART AND PERFORMANCE</div>
            <div class="talk-speaker">主讲人：连蔼理 Olli Tapio Leino，香港城市大学创意媒体学院副教授</div>
          </div>
        </div>
      </article>

      <article class="session-card">
        <h3>赛博文本</h3>
        <div class="session-en">Cybertext</div>
        <div class="session-meta">
          <span>时间：13:30-17:50</span>
          <span>地点：燕京学堂报告厅 / B102</span>
        </div>
        <div class="session-note"><strong>评议嘉宾</strong>韩宇华（北京大学艺术学院博士后）、傅善超（独立学者）。</div>
        <div class="talk-list">
          <div class="talk-item">
            <div class="talk-time">13:30-13:50</div>
            <div class="talk-title">具器易身：论电子游戏如何配置知觉与行动</div>
            <div class="talk-title-en">ENTECHNOMENT: ON HOW VIDEOGAMES CONFIGURE PERCEPTION AND ACTION</div>
            <div class="talk-speaker">主讲人：耿游子民</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">13:50-14:10</div>
            <div class="talk-title">规则与规范之间：从自然法视角审视《绝地求生》中的被动生存现象</div>
            <div class="talk-title-en">BETWEEN RULES AND NORMS: UNDERSTANDING PASSIVE SURVIVAL IN PUBG THROUGH NATURAL LAW</div>
            <div class="talk-speaker">主讲人：徐开静</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">14:10-14:30</div>
            <div class="talk-title">超越道德选择的伦理力</div>
            <div class="talk-title-en">ETHICAL FORCE BEYOND MORAL CHOICE</div>
            <div class="talk-speaker">主讲人：沙晏玮</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">14:30-14:50</div>
            <div class="talk-title">进入反身的时刻：在电子游戏“打破第四面墙”之后</div>
            <div class="talk-title-en">ENTERING THE MOMENT OF REFLEXIVITY: AFTER VIDEO GAMES “BREAK THE FOURTH WALL”</div>
            <div class="talk-speaker">主讲人：李苒</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">15:10-15:30</div>
            <div class="talk-title">作为工作界面的参数配置表：虚幻引擎管线的媒介考古</div>
            <div class="talk-title-en">PARAMETER CONFIGURATION TABLES AS WORKING INTERFACE: A MEDIA ARCHAEOLOGY OF THE UNREAL ENGINE PIPELINE</div>
            <div class="talk-speaker">主讲人：陈超锐</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">15:30-15:50</div>
            <div class="talk-title">我的代码在你之上！论电子游戏的代码裸露与游戏规则的边界协商</div>
            <div class="talk-title-en">MY CODE IS ABOVE YOURS! ON THE EXPOSURE OF CODE AND THE NEGOTIATION OF THE BOUNDARIES OF VIDEO GAME RULES</div>
            <div class="talk-speaker">主讲人：赵翔</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">15:50-16:10</div>
            <div class="talk-title">当规则命令你犯规：作弊作为力的多种切入与反作用力</div>
            <div class="talk-title-en">WHEN RULES COMMAND YOU TO BREAK THEM: CHEATING AS MULTIPLE INTERVENTIONS OF FORCE AND COUNTERFORCE</div>
            <div class="talk-speaker">主讲人：闫毅航</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">16:30-16:50</div>
            <div class="talk-title">操作性与非操作性之间：论电子游戏隐藏空间的元空间性</div>
            <div class="talk-title-en">BETWEEN OPERATIVITY AND INOPERATIVITY: THE METASPATIALITY OF HIDDEN SPACES IN VIDEO GAMES</div>
            <div class="talk-speaker">主讲人：于书瀚</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">16:50-17:10</div>
            <div class="talk-title">游戏空间中的无形之力：电子游戏的空间绅士化与玩家抵抗</div>
            <div class="talk-title-en">THE INVISIBLE FORCE OF GAMESPACE: SPATIAL GENTRIFICATION AND PLAYER RESISTANCE IN VIDEO GAMES</div>
            <div class="talk-speaker">主讲人：闫琨骜</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">17:10-17:30</div>
            <div class="talk-title">我们游玩的隐喻：规则、机制、模拟，还是其他？</div>
            <div class="talk-title-en">THE METAPHORS WE PLAY BY: RULES, MECHANICS, SIMULATIONS, OR SOMETHING ELSE?</div>
            <div class="talk-speaker">主讲人：艾斯本·奥赛特</div>
          </div>
        </div>
      </article>

      <article class="session-card">
        <h3>游戏改变世界</h3>
        <div class="session-en">Reality is Broken</div>
        <div class="session-meta">
          <span>时间：13:30-17:50</span>
          <span>地点：燕京学堂报告厅 / B101</span>
        </div>
        <div class="session-note"><strong>评议嘉宾</strong>李典峰（中国传媒大学动画与数字艺术学院讲师）、耿弘明（清华大学人文学院讲师）。</div>
        <div class="talk-list">
          <div class="talk-item">
            <div class="talk-time">13:30-13:50</div>
            <div class="talk-title">心理治疗师视角下电子游戏对青少年来访者的积极作用</div>
            <div class="talk-title-en">VIDEOGAMES IN ADOLESCENT CLINICAL PRACTICE: A PSYCHOTHERAPIST’S PERSPECTIVE</div>
            <div class="talk-speaker">主讲人：黄小洋</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">13:50-14:10</div>
            <div class="talk-title">为玩而玩：中国玩家对审查制度的游玩式协商：以《隐形守护者》为例</div>
            <div class="talk-title-en">PLAYING FOR THE RIGHT TO PLAY: THE PLAYFUL NEGOTIATION OF CHINESE PLAYERS WITH CENSORSHIP IN THE CASE OF THE INVISIBLE GUARDIAN</div>
            <div class="talk-speaker">主讲人：王以晨</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">14:10-14:30</div>
            <div class="talk-title">不同游戏对同一“网戒”现实与社会介入路径对比</div>
            <div class="talk-title-en">A COMPARISON OF DIFFERENT GAMES’ PATHS OF SOCIAL INTERVENTION INTO THE SAME REALITY OF “INTERNET ADDICTION TREATMENT”</div>
            <div class="talk-speaker">主讲人：彭嘉敏</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">14:30-14:50</div>
            <div class="talk-title">“你穿得像个游戏角色”：游戏角色暴露化设计如何规训玩家的现实穿着？</div>
            <div class="talk-title-en">“YOU’RE DRESSED LIKE A GAME CHARACTER”: HOW REVEALING GAME CHARACTER DESIGN DISCIPLINES PLAYERS’ REAL-WORLD CLOTHING CHOICES</div>
            <div class="talk-speaker">主讲人：张敬旺</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">15:10-15:30</div>
            <div class="talk-title">旧游戏，新机器：论游戏怀旧的“不纯性”</div>
            <div class="talk-title-en">OLD GAMES, NEW MACHINES: ON THE “IMPURITY” OF GAME NOSTALGIA</div>
            <div class="talk-speaker">主讲人：何源堃</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">15:30-15:50</div>
            <div class="talk-title">电子游戏重制与数码物的“文艺复兴”</div>
            <div class="talk-title-en">VIDEO GAME REMAKES AND THE “RENAISSANCE” OF DIGITAL OBJECTS</div>
            <div class="talk-speaker">主讲人：李坤</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">15:50-16:10</div>
            <div class="talk-title">游荡于《千禧梦》：接受视角下“数字游荡者”的主体性建构与意义生产</div>
            <div class="talk-title-en">WANDERING IN MILLENNIUM DREAMS: THE SUBJECTIVITY CONSTRUCTION AND MEANING PRODUCTION OF THE “DIGITAL FLANEUR” FROM THE PERSPECTIVE OF RECEPTION</div>
            <div class="talk-speaker">主讲人：朱冰洁</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">16:30-16:50</div>
            <div class="talk-title">吸引力的五十载进化：恋爱游戏史中的情感引力与关系演变</div>
            <div class="talk-title-en">THE FIFTY-YEAR EVOLUTION OF ATTRACTION: EMOTIONAL GRAVITY AND RELATIONAL SHIFTS IN DATING GAMES</div>
            <div class="talk-speaker">主讲人：王亚晖</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">16:50-17:10</div>
            <div class="talk-title">玩而未玩：桌面“摸鱼”游戏与互被动性</div>
            <div class="talk-title-en">PLAY WITHOUT PLAYING: DESKTOP MOYU GAMES AND INTERPASSIVITY</div>
            <div class="talk-speaker">主讲人：郭宁溪</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">17:10-17:30</div>
            <div class="talk-title">身份嬗变与解域力量：作为“美丽意外”的游戏 bug</div>
            <div class="talk-title-en">IDENTITY TRANSFORMATION AND DETERRITORIALIZING FORCE: GAME BUGS AS STUNNING ACCIDENTS</div>
            <div class="talk-speaker">主讲人：杨金珂</div>
          </div>
        </div>
      </article>
    </div>
  </section>

  <section class="schedule-panel" id="special">
    <div class="panel-head">
      <div>
        <div class="panel-title">Day 1 Extra Events</div>
        <div class="panel-subtitle">特别论坛、圆桌与夜场活动</div>
      </div>
    </div>
    <div class="session-grid">
      <article class="session-card full">
        <h3>跨学科视野下的游戏教育体系构建</h3>
        <div class="session-en">Constructing a Game Education System from an Interdisciplinary Perspective</div>
        <div class="session-meta">
          <span>时间：4/11 14:00-17:00</span>
          <span>地点：治贝子园</span>
        </div>
        <div class="session-note"><strong>主持人</strong>郑丹琪，中国传媒大学动画与数字艺术学院党委书记、研究员。</div>
        <div class="session-note"><strong>拟出席嘉宾</strong>按发言顺序排列。</div>
        <div class="guest-list">
          <div class="guest-item">王雷 | 中国传媒大学动画与数字艺术学院院长、教授</div>
          <div class="guest-item">宣学君 | 中国美术学院动画与游戏学院副院长、教授</div>
          <div class="guest-item">艾斯本·奥赛特 | 香港城市大学创意媒体学院院长、教授</div>
          <div class="guest-item">张志庆 | 澳门科技大学人文艺术学院院长、教授</div>
          <div class="guest-item">米格尔·西卡特 | 哥本哈根信息技术大学教授</div>
          <div class="guest-item">黄心渊 | 中国传媒大学动画与数字艺术学院二级教授，教育部动画、数字媒体本科教指委秘书长</div>
          <div class="guest-item">饭田弘之 | 北陆先端科学技术大学院大学副校长、教授</div>
          <div class="guest-item">丁刚毅 | 北京理工大学软件学院院长、教授</div>
          <div class="guest-item">刘梦雅 | 北京电影学院数字媒体学院院长、教授</div>
          <div class="guest-item">方媛媛 | 波克城市 HR 总监</div>
          <div class="guest-item">孙子荀 | 腾讯游戏 AI 总监</div>
          <div class="guest-item">里昂·肖 | 香港城市大学创意媒体学院助理教授</div>
          <div class="guest-item">熊硕 | 华中科技大学新闻与信息传播学院副教授</div>
          <div class="guest-item">曹琪 | 北京大学科学技术与医学史系讲师</div>
        </div>
      </article>

      <article class="session-card">
        <h3>过程即结果：AI实时生成和游戏的结合</h3>
        <div class="session-en">特别论坛</div>
        <div class="session-meta">
          <span>时间：4/11 19:00-21:00</span>
          <span>地点：燕京学堂 B101</span>
        </div>
      </article>

      <article class="session-card">
        <h3>协商物质性与物质性协商：理解游戏规则的另类视角</h3>
        <div class="session-en">圆桌讨论</div>
        <div class="session-meta">
          <span>时间：4/11 19:00-21:00</span>
          <span>地点：燕京学堂 B102</span>
        </div>
      </article>

      <article class="session-card">
        <h3>电子竞技 3.0 时代与国家赛事的兴起</h3>
        <div class="session-en">电竞圆桌夜</div>
        <div class="session-meta">
          <span>时间：4/11 19:00-21:00</span>
          <span>地点：双创中心半圆厅（二教地下）</span>
        </div>
      </article>

      <article class="session-card">
        <h3>清华大学哲学学堂班第五届交叉论坛暨 2026 博雅国际电子游戏学术年会分论坛</h3>
        <div class="session-meta">
          <span>时间：04/12 09:00-12:00</span>
          <span>地点：燕南园 50 号院</span>
        </div>
        <div class="session-note"><strong>学术主持</strong>夏莹，清华大学人文学院副院长、日新书院副院长、教授。<strong>评议人</strong>蓝江（南京大学哲学系教授）、连蔼理（香港城市大学副教授）。</div>
      </article>
    </div>
  </section>

  <section class="schedule-panel" id="day2">
    <div class="panel-head">
      <div>
        <div class="panel-title">Day 2 / 04.12</div>
        <div class="panel-subtitle">帝国的游戏、游戏感与闭幕安排</div>
      </div>
    </div>
    <div class="session-grid">
      <article class="session-card">
        <h3>帝国的游戏</h3>
        <div class="session-en">Game of Empires</div>
        <div class="session-meta">
          <span>时间：09:00-15:20</span>
          <span>地点：燕京学堂报告厅 / B102</span>
        </div>
        <div class="session-note"><strong>评议嘉宾</strong>何源堃（中南财经政法大学中韩新媒体学院讲师）、杨云鬯（北京大学社会学系助理教授、研究员）、曹琪（北京大学科学技术与医学史系讲师）、王洪喆（北京大学新闻与传播学院长聘副教授）。</div>
        <div class="talk-list">
          <div class="talk-item">
            <div class="talk-time">09:00-09:20</div>
            <div class="talk-title">治安战的帧率：军事射击游戏的界面政治与数字劳作</div>
            <div class="talk-title-en">THE FRAME RATE OF POLICING OPERATIONS: INTERFACE POLITICS AND DIGITAL LABOR OF MILITARY SHOOTER GAMES</div>
            <div class="talk-speaker">主讲人：吴文杰</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">09:20-09:40</div>
            <div class="talk-title">“游戏化清算”装置：《大富翁》游戏地租机制演变研究</div>
            <div class="talk-title-en">GAMIFIED LIQUIDATION: AN ARCHAEOLOGICAL STUDY ON RENT MECHANICS IN MONOPOLY</div>
            <div class="talk-speaker">主讲人：宋涵</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">09:40-10:00</div>
            <div class="talk-title">规制的物质性：EULA 如何在数字游戏世界中转化为程序性权力</div>
            <div class="talk-title-en">THE MATERIALITY OF REGULATION: HOW EULAS BECOME PROCEDURAL POWER IN DIGITAL GAME WORLDS</div>
            <div class="talk-speaker">主讲人：徐瑞钰</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">10:00-10:20</div>
            <div class="talk-title">拟父异托邦：Pay-to-win 策略游戏的秩序建构与欲望生产</div>
            <div class="talk-title-en">PSEUDO-PATERNAL HETEROTOPIA: ORDER CONSTRUCTION AND DESIRE PRODUCTION IN PAY-TO-WIN STRATEGY GAMES — A CASE STUDY OF THREE KINGDOMS TACTICS</div>
            <div class="talk-speaker">主讲人：王一楠</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">10:40-11:00</div>
            <div class="talk-title">谁在定义“值”：玩家游戏实践如何改写虚拟物品交易</div>
            <div class="talk-title-en">WHO DEFINES WHAT COUNTS AS VALUABLE? HOW PLAYERS’ GAMING PRACTICES RECONFIGURE VIRTUAL ITEM TRADING: EVIDENCE FROM THE IDENTITY V TRADING BAR</div>
            <div class="talk-speaker">主讲人：刘祎培</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">11:00-11:20</div>
            <div class="talk-title">虚拟江湖的“拟态法庭”：剑网3“818”文化中的道德规训与权力运作</div>
            <div class="talk-title-en">THE “SIMULATED COURT” OF THE VIRTUAL JIANGHU: MORAL DISCIPLINE AND THE OPERATION OF POWER IN THE “818” CULTURE OF SWORD OF LEGENDS ONLINE</div>
            <div class="talk-speaker">主讲人：孟畅</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">11:20-11:40</div>
            <div class="talk-title">多重治理结构中的策略性情感施为：中国乙女游戏的亲密秩序生产</div>
            <div class="talk-title-en">STRATEGIC EMOTIVES WITHIN MULTIPLE GOVERNANCE STRUCTURES: THE PRODUCTION OF INTIMACY ORDERS IN CHINESE OTOME GAMES</div>
            <div class="talk-speaker">主讲人：苏成琳</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">13:00-13:20</div>
            <div class="talk-title">西方历史游戏中中国内容的再现危机：基于《十字军之王 3》的跨文化批判性考察</div>
            <div class="talk-title-en">THE CRISIS OF REPRESENTING CHINESE CONTENT IN WESTERN HISTORICAL GAMES: A CROSS-CULTURAL CRITICAL STUDY BASED ON CRUSADER KINGS III</div>
            <div class="talk-speaker">主讲人：朱巧倩</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">13:20-13:40</div>
            <div class="talk-title">帝国的游戏与自然之力：从“面包与马戏”到电子游戏的物质基础</div>
            <div class="talk-title-en">GAMES OF EMPIRE AND THE FORCES OF NATURE: FROM “BREAD AND CIRCUSES” TO THE MATERIAL FOUNDATIONS OF VIDEOGAMES</div>
            <div class="talk-speaker">主讲人：卢雅怀</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">14:20-14:40</div>
            <div class="talk-title">Gamejam Alien？中国 GameJam 文化的创意工具化与制度畸变</div>
            <div class="talk-title-en">GAMEJAM ALIEN? THE CREATIVE INSTRUMENTALIZATION AND INSTITUTIONAL DISTORTION OF GAMEJAM CULTURE IN CHINA</div>
            <div class="talk-speaker">主讲人：陈正浩</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">14:40-15:00</div>
            <div class="talk-title">耳听为证：电子游戏声音的跨媒介文化建构与声景民族主义</div>
            <div class="talk-title-en">EAR-WITNESSING: THE TRANSMEDIA CULTURAL CONSTRUCTION OF VIDEOGAME SOUND AND SOUNDSCAPE NATIONALISM</div>
            <div class="talk-speaker">主讲人：杨剑秋</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">14:40-15:00</div>
            <div class="talk-title">从帝国到遗产：Flash“闪客”独立精神实践中的历史记忆与技术抵抗</div>
            <div class="talk-title-en">FROM EMPIRE TO LEGACY: HISTORICAL MEMORY AND TECHNICAL RESISTANCE IN FLASH “FLASH PLAYER” INDEPENDENT SPIRIT PRACTICE</div>
            <div class="talk-speaker">主讲人：李翔</div>
          </div>
        </div>
      </article>

      <article class="session-card">
        <h3>游戏感</h3>
        <div class="session-en">Playing with Feelings</div>
        <div class="session-meta">
          <span>时间：09:00-15:40</span>
          <span>地点：燕京学堂报告厅 / B101</span>
        </div>
        <div class="session-note"><strong>评议嘉宾</strong>王鑫（山东大学文学院助理研究员）、闫毅航（北京师范大学艺术与传媒学院博士研究生）、姜宇辉（华东师范大学政治与国际关系学院教授）、李雨谏（中国传媒大学戏剧影视学院副教授）。</div>
        <div class="talk-list">
          <div class="talk-item">
            <div class="talk-time">09:00-09:20</div>
            <div class="talk-title">栖居的抵抗：游戏“地方感”生成中程序性规则与情感力的博弈</div>
            <div class="talk-title-en">THE RESISTANCE OF DWELLING: THE CONTEST BETWEEN PROCEDURAL RULES AND AFFECTIVE FORCES IN THE FORMATION OF SENSE OF PLACE IN GAMES</div>
            <div class="talk-speaker">主讲人：白佳榕</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">09:20-09:40</div>
            <div class="talk-title">玩物造址：电子游戏的空间纹理与玩家的地方感生成</div>
            <div class="talk-title-en">LUDIC PLACEMAKING: SPATIAL TEXTURES AND THE GENERATION OF SENSE OF PLACE IN VIDEO GAMES</div>
            <div class="talk-speaker">主讲人：王礼耀</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">09:40-10:00</div>
            <div class="talk-title">“门”并未上锁：脑类银河城游戏中的“知识锁”与世界“可读性”展开</div>
            <div class="talk-title-en">THE GATE WAS NEVER LOCKED: KNOWLEDGE GATES AND THE UNFOLDING OF WORLD LEGIBILITY IN METROIDBRAINIA GAMES</div>
            <div class="talk-speaker">主讲人：张家维</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">10:00-10:20</div>
            <div class="talk-title">策略游戏中的延迟兑现与期待结构：时间结构的分析框架</div>
            <div class="talk-title-en">DELAYED PAYOFF AND EXPECTATION STRUCTURE IN STRATEGY GAMES: AN ANALYTICAL FRAMEWORK OF TIME STRUCTURE — TAKING CIVILIZATION VI AS AN EXAMPLE</div>
            <div class="talk-speaker">主讲人：刘子瑄</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">10:40-11:00</div>
            <div class="talk-title">当同一种力量作用于不同规则：人格如何中介游戏难度体验</div>
            <div class="talk-title-en">WHEN THE SAME FORCE HITS DIFFERENT RULES: PERSONALITY MEDIATES THE EXPERIENCE OF GAME DIFFICULTY</div>
            <div class="talk-speaker">主讲人：赵麟琪</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">11:00-11:20</div>
            <div class="talk-title">基于 MR 技术的游戏机制与 ADHD 心理同构</div>
            <div class="talk-title-en">EMBODIED EMPATHY IN MIXED REALITY: TRANSLATING ADHD EXPERIENCE THROUGH GAME MECHANICS</div>
            <div class="talk-speaker">主讲人：吕怡霄</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">11:20-11:40</div>
            <div class="talk-title">恐怖游戏何以恐怖：否定规则的“致恐术”</div>
            <div class="talk-title-en">THE HORROR OF HORROR GAMES: “SCARE TACTICS” AS RULE NEGATION</div>
            <div class="talk-speaker">主讲人：朱鑫瑞</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">13:00-13:20</div>
            <div class="talk-title">窥视与交互：《后窗》与《传世不朽》紧张情绪营造的跨媒介比较研究</div>
            <div class="talk-title-en">BUILDING TENSION IN REAR WINDOW AND IMMORTALITY: AN INTERMEDIAL COMPARATIVE STUDY</div>
            <div class="talk-speaker">主讲人：杨帆</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">13:20-13:40</div>
            <div class="talk-title">投币、扳机与银幕：电子游戏与电影的控制器谱系</div>
            <div class="talk-title-en">COIN, TRIGGER, AND SCREEN: A GENEALOGY OF THE CONTROLLER IN VIDEO GAMES AND CINEMA</div>
            <div class="talk-speaker">主讲人：龚毓伦</div>
          </div>
          <div class="talk-item" data-title-mode="en-only">
            <div class="talk-time">13:40-14:00</div>
            <div class="talk-title">僵尸题材“影-游”互动的生命政治屏幕谱系</div>
            <div class="talk-title-en">THE BIOPOLITICAL SCREENS GENEALOGY OF FILM–GAME INTERACTION IN ZOMBIE MEDIA</div>
            <div class="talk-speaker">主讲人：苏源</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">14:20-14:40</div>
            <div class="talk-title">弹道、感知与反思：第一人称视点游戏的功能对话与知觉谱系考察</div>
            <div class="talk-title-en">BALLISTICS, PERCEPTION, AND REFLECTION: A STUDY ON THE FUNCTIONAL DIALOGUE AND GENEALOGY OF PERCEPTION IN FIRST-PERSON PERSPECTIVE GAMES</div>
            <div class="talk-speaker">主讲人：毛增立</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">14:40-15:00</div>
            <div class="talk-title">如何说再见：《主播女孩重度依赖》中的拯救幻想与主体性倒置</div>
            <div class="talk-title-en">COMMENT TE DIRE ADIEU: THE RESCUE FANTASY AND THE INVERSION OF SUBJECTIVITY IN NEEDY GIRL OVERDOSE</div>
            <div class="talk-speaker">主讲人：张嘉林</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">15:00-15:20</div>
            <div class="talk-title">于规则消隐处：电子游戏的气氛、世界与共同体想象</div>
            <div class="talk-title-en">BEYOND THE RULES: ATMOSPHERE, WORLD, AND COMMUNITY IMAGINATION IN ELECTRONIC GAMES</div>
            <div class="talk-speaker">主讲人：杨奕</div>
          </div>
        </div>
      </article>

      <article class="session-card full">
        <h3>闭幕式与主题演讲</h3>
        <div class="session-en">Closing Ceremony & Final Keynote</div>
        <div class="session-meta">
          <span>时间：15:30-16:50</span>
          <span>地点：燕京学堂报告厅 / B102</span>
        </div>
        <div class="talk-list">
          <div class="talk-item">
            <div class="talk-time">15:30-16:00</div>
            <div class="talk-title">闭幕式 / Closing Ceremony</div>
          </div>
          <div class="talk-item">
            <div class="talk-time">16:00-16:50</div>
            <div class="talk-title">游戏与暴力：生存或杀戮</div>
            <div class="talk-title-en">GAMES AND VIOLENCE: TO SURVIVE OR TO KILL</div>
            <div class="talk-speaker">主讲人：姜宇辉 Jiang Yuhui，华东师范大学政治与国际关系学院教授</div>
          </div>
        </div>
      </article>
    </div>
  </section>

  <section class="schedule-panel" id="organization">
    <div class="panel-head">
      <div>
        <div class="panel-title">Organization</div>
        <div class="panel-subtitle">会议组织与支持信息</div>
      </div>
    </div>
    <div class="info-list">
      <div><strong>主办单位</strong>北京大学艺术学院、中国传媒大学动画与数字艺术学院、游戏与艺术创研中心</div>
      <div><strong>学术支持</strong>《文艺理论研究》《中国艺术》《北京电影学院学报》《当代电影》《电影艺术》《游戏研究》《文化艺术研究》《当代动画》《电子竞技》</div>
      <div><strong>指导单位</strong>中国高等院校影视学会</div>
      <div><strong>合作单位</strong>清华学堂人才培养计划哲学学堂班、北京大学艺术学院计算艺术实验室、北京大学图像学实验室、中国艺术研究院艺术哲学与艺术史研究中心</div>
      <div><strong>机构支持</strong>波克城市、中国音数协游戏博物馆、KCL Digital Gaming Lab、Retro Game Museum</div>
      <div><strong>独家学术直播</strong>图像之书</div>
      <div><strong>会议官方公众平台</strong>未名游戏</div>
      <div><strong>茶歇饮品支持</strong>喜茶</div>
      <div><strong>媒体与平台支持</strong>北京大学融媒体中心、游研社、信睿周报、游戏机实用技术、落日间、触乐、游戏葡萄、Indienova、央视网、人民电竞、新浪游戏、中国新闻网</div>
      <div><strong>组委会主席</strong>李洋</div>
      <div><strong>秘书长</strong>耿游子民</div>
      <div><strong>学术统筹</strong>傅善超</div>
      <div><strong>国际统筹</strong>朱鑫瑞</div>
      <div><strong>会务统筹</strong>沈思源、郑博航</div>
      <div><strong>宣传统筹</strong>陈佳苗</div>
      <div><strong>视觉统筹</strong>夏天</div>
      <div><strong>视觉设计</strong>夏天、卢博涵、洪羽萱、林安</div>
      <div><strong>媒体统筹</strong>李典峰</div>
      <div><strong>技术统筹</strong>陈想、李响</div>
      <div><strong>特别鸣谢</strong>张云帆</div>
      <div><strong>学术委员会</strong>曹琪、傅善超、耿弘明、耿游子民、何源堃、韩宇华、刘书亮、李典峰、李洋、李雨谏、卢雅怀、施畅、孙凝翔、汪博、王安础、王洪喆、王鑫、熊硕、杨云鬯、闫毅航、周思妤、朱鑫瑞。</div>
      <div><strong>会务志愿者</strong>张子颖、张子墨、余同、李之剑、武益辰、翟嘉骏、陈赛亚、李雨庭、邢楚嫣、姚梦溪、李思雨、李果芙、马茜、焦子淇、刘文想、张骁骏</div>
    </div>
  </section>
`;

const TITLE_ACRONYMS = new Set(['ADHD', 'EULAS', 'MR', 'PUBG', 'IP', 'MOD', 'MODS', 'NPC', 'FPP']);
const abstractByTitleZh = new Map();
const abstractByTitleEn = new Map();
const abstractBySpeaker = new Map();

const normalizeText = (value) =>
  String(value || '')
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/&[a-z]+;/g, ' ')
    .replace(/[^0-9a-z\u4e00-\u9fff]+/g, '');

const normalizeSpeaker = (value) => {
  const speakerText = String(value || '')
    .replace(/^主讲人[:：]\s*/, '')
    .trim()
    .split('，')[0]
    .split(',')[0]
    .trim();

  return normalizeText(speakerText);
};

const registerAbstractRecord = (map, key, record) => {
  if (key && !map.has(key)) {
    map.set(key, record);
  }
};

const formatEnglishTitle = (value) =>
  String(value || '').replace(/[A-Za-z][A-Za-z'’-]*/g, (word) => {
    if (word !== word.toUpperCase()) {
      return word;
    }

    const normalized = word.replace(/[’']/g, "'");
    if (TITLE_ACRONYMS.has(normalized)) {
      return normalized;
    }

    if (normalized.length <= 1) {
      return normalized;
    }

    return normalized.charAt(0) + normalized.slice(1).toLowerCase();
  });

conference2026Abstracts.forEach((record) => {
  registerAbstractRecord(abstractByTitleZh, normalizeText(record.titleZh), record);
  registerAbstractRecord(abstractByTitleEn, normalizeText(record.titleEn), record);
  registerAbstractRecord(abstractBySpeaker, normalizeSpeaker(record.speaker), record);
});

const getDirectChild = (parent, className) =>
  Array.from(parent.children).find((child) => child.classList && child.classList.contains(className));

const getDirectChildren = (parent, className) =>
  Array.from(parent.children).filter((child) => child.classList && child.classList.contains(className));

const findAbstractRecord = ({ titleZh, titleEn, speaker }) =>
  abstractByTitleZh.get(normalizeText(titleZh)) ||
  abstractByTitleEn.get(normalizeText(titleEn)) ||
  abstractBySpeaker.get(normalizeSpeaker(speaker));

const parseTalkItem = (item, panelId, sessionIndex, talkIndex) => {
  const rawTitleZh = item.querySelector('.talk-title')?.textContent?.trim() || '';
  const rawTitleEn = item.querySelector('.talk-title-en')?.textContent?.trim() || '';
  const speaker = item.querySelector('.talk-speaker')?.textContent?.trim() || '';
  const record = findAbstractRecord({
    titleZh: rawTitleZh,
    titleEn: rawTitleEn,
    speaker
  });
  const forceEnglishOnly = item.dataset.titleMode === 'en-only';
  const englishOnly = forceEnglishOnly || Boolean(record && !record.titleZh && (record.titleEn || rawTitleEn));
  const title = englishOnly
    ? formatEnglishTitle(record?.titleEn || rawTitleEn || rawTitleZh)
    : record?.titleZh || rawTitleZh;
  const titleEn = englishOnly ? '' : formatEnglishTitle(record?.titleEn || rawTitleEn);

  return {
    id: record?.id || `${panelId}-${sessionIndex}-${talkIndex}`,
    time: item.querySelector('.talk-time')?.textContent?.trim() || '',
    title,
    titleEn,
    speaker,
    abstractZh: record?.abstractZh || '',
    abstractEn: record?.abstractEn || '',
    hasAbstract: Boolean(record && (record.abstractZh || record.abstractEn))
  };
};

const parseSessionCard = (card, panelId, sessionIndex) => {
  const talkList = getDirectChild(card, 'talk-list');
  const guestList = getDirectChild(card, 'guest-list');
  const meta = getDirectChild(card, 'session-meta');

  return {
    id: `${panelId}-session-${sessionIndex}`,
    isFull: card.classList.contains('full'),
    title: card.querySelector('h3')?.textContent?.trim() || '',
    titleEn: getDirectChild(card, 'session-en')?.textContent?.trim() || '',
    meta: meta ? Array.from(meta.children).map((node) => node.textContent.trim()) : [],
    notes: getDirectChildren(card, 'session-note').map((node) => node.innerHTML.trim()),
    guestItems: guestList ? Array.from(guestList.children).map((node) => node.textContent.trim()) : [],
    talks: talkList
      ? Array.from(talkList.children)
          .filter((node) => node.classList && node.classList.contains('talk-item'))
          .map((node, talkIndex) => parseTalkItem(node, panelId, sessionIndex, talkIndex))
      : []
  };
};

const buildSchedulePanels = () => {
  if (typeof DOMParser === 'undefined') {
    return [];
  }

  const parser = new DOMParser();
  const documentNode = parser.parseFromString(`<div>${schedulePanelsMarkup}</div>`, 'text/html');
  const wrapper = documentNode.body.firstElementChild;

  if (!wrapper) {
    return [];
  }

  return Array.from(wrapper.children)
    .filter((node) => node.classList && node.classList.contains('schedule-panel'))
    .map((panel) => {
      const panelHead = getDirectChild(panel, 'panel-head');
      const title = panelHead?.querySelector('.panel-title')?.textContent?.trim() || '';
      const subtitle = panelHead?.querySelector('.panel-subtitle')?.textContent?.trim() || '';
      const infoList = getDirectChild(panel, 'info-list');
      const sessionGrid = getDirectChild(panel, 'session-grid');

      return {
        id: panel.id,
        title,
        subtitle,
        infoItems: infoList ? Array.from(infoList.children).map((node) => node.innerHTML.trim()) : [],
        sessions: sessionGrid
          ? Array.from(sessionGrid.children)
              .filter((node) => node.classList && node.classList.contains('session-card'))
              .map((node, sessionIndex) => parseSessionCard(node, panel.id, sessionIndex))
          : []
      };
    });
};

const schedulePanels = buildSchedulePanels();

function ScheduleText({ language = 'zh' }) {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [openTalks, setOpenTalks] = useState({});

  const copy = {
    zh: {
      eyebrow: '2026 Boya International Academic Conference on Video Game',
      title: '2026 Boya International Academic Conference on Video Game',
      subtitle: '2026博雅国际电子游戏学术年会',
      day1: '04/11 第一日',
      day2: '04/12 第二日',
      special: '特别论坛',
      organization: '组织机构',
      hint: '提示：点击任一发言条目可以展开或收起摘要。摘要会跟随页面当前语言切换。',
      dateLabel: '时间',
      dateValue: '2026年4月11日-12日',
      venueLabel: '地点',
      venueValue: '北京大学燕京学堂报告厅',
      backToTop: '返回顶部',
      abstractLabel: '点击查看摘要',
      abstractHideLabel: '点击收起摘要',
      abstractHeading: '摘要',
      abstractUnavailable: '暂无对应语言摘要。'
    },
    en: {
      eyebrow: '2026 Boya International Academic Conference on Video Game',
      title: '2026 Boya International Academic Conference on Video Game',
      subtitle: '2026博雅国际电子游戏学术年会',
      day1: '04/11 Day One',
      day2: '04/12 Day Two',
      special: 'Special Forum',
      organization: 'Organization',
      hint: 'Tip: Click any presentation item to expand or collapse its abstract. Abstracts follow the current page language.',
      dateLabel: 'Date',
      dateValue: 'April 11-12, 2026',
      venueLabel: 'Venue',
      venueValue: 'Yenching Academy Report Hall, Peking University',
      backToTop: 'Back to Top',
      abstractLabel: 'Click to View Abstract',
      abstractHideLabel: 'Click to Hide Abstract',
      abstractHeading: 'Abstract',
      abstractUnavailable: 'Abstract unavailable in English.'
    }
  }[language] || {
    eyebrow: '2026 Boya International Academic Conference on Video Game',
    title: '2026 Boya International Academic Conference on Video Game',
    subtitle: '2026博雅国际电子游戏学术年会'
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 260);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const getAbstractText = (talk) => {
    if (language === 'en') {
      return talk.abstractEn || copy.abstractUnavailable;
    }

    return talk.abstractZh || copy.abstractUnavailable;
  };

  const toggleAbstract = (talkId) => {
    setOpenTalks((current) => ({
      ...current,
      [talkId]: !current[talkId]
    }));
  };

  return (
    <section className="schedule-page" id="scheduletext">
      <div className="schedule-shell">
        <section className="schedule-hero">
          <div className="hero-copy">
            <div className="schedule-eyebrow">{copy.eyebrow}</div>
            <h1 className="schedule-title">
              {copy.title}
              <span className="schedule-title-zh">{copy.subtitle}</span>
            </h1>

            <div className="schedule-quick-links">
              <a className="schedule-chip" href="#day1">{copy.day1}</a>
              <a className="schedule-chip" href="#day2">{copy.day2}</a>
              <a className="schedule-chip" href="#special">{copy.special}</a>
              <a className="schedule-chip" href="#organization">{copy.organization}</a>
            </div>

            <div className="schedule-interaction-hint">{copy.hint}</div>

            <div className="schedule-meta-row" id="overview">
              <div className="schedule-meta-card">
                <strong>{copy.dateLabel}</strong>
                <span>{copy.dateValue}</span>
              </div>
              <div className="schedule-meta-card">
                <strong>{copy.venueLabel}</strong>
                <span>{copy.venueValue}</span>
              </div>
            </div>
          </div>
        </section>

        <div className="schedule-layout">
          <div className="schedule-main">
            {schedulePanels.map((panel) => (
              <section key={panel.id} className="schedule-panel" id={panel.id}>
                <div className="panel-head">
                  <div>
                    <div className="panel-title">{panel.title}</div>
                    <div className="panel-subtitle">{panel.subtitle}</div>
                  </div>
                </div>

                {panel.sessions.length > 0 ? (
                  <div className="session-grid">
                    {panel.sessions.map((session) => (
                      <article
                        key={session.id}
                        className={`session-card${session.isFull ? ' full' : ''}`}
                      >
                        <h3>{session.title}</h3>
                        {session.titleEn ? <div className="session-en">{session.titleEn}</div> : null}

                        {session.meta.length > 0 ? (
                          <div className="session-meta">
                            {session.meta.map((metaItem, index) => (
                              <span key={`${session.id}-meta-${index}`}>{metaItem}</span>
                            ))}
                          </div>
                        ) : null}

                        {session.notes.map((note, index) => (
                          <div
                            key={`${session.id}-note-${index}`}
                            className="session-note"
                            dangerouslySetInnerHTML={{ __html: note }}
                          />
                        ))}

                        {session.guestItems.length > 0 ? (
                          <div className="guest-list">
                            {session.guestItems.map((guestItem, index) => (
                              <div key={`${session.id}-guest-${index}`} className="guest-item">
                                {guestItem}
                              </div>
                            ))}
                          </div>
                        ) : null}

                        {session.talks.length > 0 ? (
                          <div className="talk-list">
                            {session.talks.map((talk) => {
                              const isOpen = Boolean(openTalks[talk.id]);

                              return (
                                <div
                                  key={talk.id}
                                  className={`talk-item${talk.hasAbstract ? ' has-abstract' : ''}${isOpen ? ' abstract-open' : ''}`}
                                  data-abstract-label={talk.hasAbstract ? (isOpen ? copy.abstractHideLabel : copy.abstractLabel) : undefined}
                                  role={talk.hasAbstract ? 'button' : undefined}
                                  tabIndex={talk.hasAbstract ? 0 : undefined}
                                  aria-expanded={talk.hasAbstract ? String(isOpen) : undefined}
                                  onClick={talk.hasAbstract ? () => toggleAbstract(talk.id) : undefined}
                                  onKeyDown={
                                    talk.hasAbstract
                                      ? (event) => {
                                          if (event.key === 'Enter' || event.key === ' ') {
                                            event.preventDefault();
                                            toggleAbstract(talk.id);
                                          }
                                        }
                                      : undefined
                                  }
                                >
                                  {talk.time ? <div className="talk-time">{talk.time}</div> : null}
                                  <div className="talk-title">{talk.title}</div>
                                  {talk.titleEn ? <div className="talk-title-en">{talk.titleEn}</div> : null}
                                  {talk.speaker ? <div className="talk-speaker">{talk.speaker}</div> : null}

                                  {talk.hasAbstract && isOpen ? (
                                    <div className="talk-abstract">
                                      <strong className="talk-abstract-label">{copy.abstractHeading}</strong>
                                      <div className="talk-abstract-body">{getAbstractText(talk)}</div>
                                    </div>
                                  ) : null}
                                </div>
                              );
                            })}
                          </div>
                        ) : null}
                      </article>
                    ))}
                  </div>
                ) : null}

                {panel.infoItems.length > 0 ? (
                  <div className="info-list">
                    {panel.infoItems.map((item, index) => (
                      <div
                        key={`${panel.id}-info-${index}`}
                        dangerouslySetInnerHTML={{ __html: item }}
                      />
                    ))}
                  </div>
                ) : null}
              </section>
            ))}
          </div>

          <aside className="schedule-sidebar">
            <ConferenceCountdown language={language} />
          </aside>
        </div>
      </div>

      <button
        className={`back-to-top ${showBackToTop ? 'visible' : ''}`}
        type="button"
        aria-label={copy.backToTop}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      >
        {copy.backToTop}
      </button>
    </section>
  );
}

export default ScheduleText;
